type BuildingType = { [key: string]: string };

export const getTypeFilterOptions = (buildingType: BuildingType) =>
  Object.entries(buildingType).map(([name, type]) => ({
    data: { id: type, name: `pages.current_item.categories.id_${type}` },
    name: `new-search-type-filter__${name.toLowerCase()}`
  }));
